<template>
  <div name="hres7de-group">
    <div class="evaluation-header clearfix cursor-pointer border-top-color-skin" @click="toggleGroup()">
      <div class="col-xs-8 clear-padding">
        <div class="col-xs-12 col-md-3 clear-padding">{{ labels['HRES7DEP2']['30'] }} {{ dataGroup.numgrup }}</div>
        <div class="col-xs-12 col-md-7 clear-padding evaluation-title">{{ dataGroup.desc_numgrup }}</div>
      </div>
      <div class="col-xs-4 clear-padding evaluation-score">{{ calResultScore(dataGroup) }}/{{ calTotalScore(dataGroup) }}</div>
    </div>
    <div class="evaluation-body" v-show="groupDisp">
      <div class="evaluation-section clearfix">
        <template v-for="(item, index) in dataGroup.numitem">
          <hres7de-item :dataGroup="dataGroup"
                        :item="item"
                        :choices="choices"
                        :name="name"
                        :key="index" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import hres7deItem from 'components/hres7de/item'
import { numberFormat } from 'assets/js/numberFormat.js'

export default {
  name: 'hres7de-group',
  data () {
    return {
      groupDisp: false
    }
  },
  props: {
    labels: {
      type: Object
    },
    dataGroup: {
      type: Object,
      required: true
    },
    choices: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  },
  methods: {
    toggleGroup () {
      this.groupDisp = !this.groupDisp
    },
    calResultScore (dataGroup) {
      let groupQtyscor = dataGroup.numitem.map((item) => {
        return parseFloat(item.qtyscor)
      }).reduce((a, b) => {
        return parseFloat(a) + parseFloat(b)
      })
      this.$set(dataGroup, 'qtyscore', groupQtyscor)
      return numberFormat(groupQtyscor)
    },
    getFormat (val) {
      return numberFormat(parseFloat(val))
    },
    calTotalScore (dataGroup) {
      let groupQtyfscor = dataGroup.numitem.map((item) => {
        return parseFloat(item.qtyfscor)
      }).reduce((a, b) => {
        return parseFloat(a) + parseFloat(b)
      })
      this.$set(dataGroup, 'qtyfscor', groupQtyfscor)
      return numberFormat(groupQtyfscor)
    }
  },
  components: {
    hres7deItem
  }
}
</script>



// WEBPACK FOOTER //
// group.vue?1d0c173e